import PropTypes from "prop-types";
import { TableStyled } from "./TableStyled";
import Loader from "../Loader/Loader";
import { Box } from "@mui/material";

const Table = ({
  columns,
  data,
  loading = false,
  loadingComponent = null,
  rowSelection,
  emptyMessage,
  tableheight,
  setNewSortOrder,
  newSortOrder,
  onDragLeave,
  ...props
}) => {
  if (loading) {
    return loadingComponent || <Loader />;
  }

  return (
    <Box onDragLeave={onDragLeave}>
      <TableStyled
        columns={columns}
        dataSource={data}
        loading={loading}
        // Row checkboxes render only when a caller passes rowSelection
        // (undefined = no selection column, so other Table consumers are
        // unaffected). TabView passes it to power bulk actions like
        // "Merge selected".
        rowSelection={rowSelection}
        rowKey={(record) => record?.id || record?.key || record?.unique_id}
        pagination={false}
        locale={{
          emptyText: emptyMessage,
        }}
        {...props}
      />
    </Box>
  );
};

Table.propTypes = {
  columns: PropTypes.array.isRequired,
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  loadingComponent: PropTypes.node,
  rowSelection: PropTypes.object,
  tableheight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  setNewSortOrder: PropTypes.func,
  newSortOrder: PropTypes.object,
  emptyMessage: PropTypes.node,
  onDragLeave: PropTypes.func,
};

export default Table;
